import React, {Component} from 'react';
import {MuiThemeProvider, createMuiTheme} from 'material-ui/styles';
import {Provider} from 'react-redux';
import Root from './Root';
import configureStore from './store/configureStore';
import CssBaseline from 'material-ui/CssBaseline';
import {colors} from './styles/colors';
import * as configuration from './utils/configuration';
import {I18nextProvider} from 'react-i18next';
import i18n from './utils/i18n';
import ReactGA from 'react-ga';
const theme = createMuiTheme({
	palette: {
		primary: {
			light: colors.primaryColor_light,
			main: colors.primaryColor,
			dark: colors.primaryColor_dark,
			contrastText: colors.white,
		},
		error: {
			main: colors.red,
		},
		secondary: {
			light: colors.dirty_white,
			main: colors.primaryColor_light,
			dark: colors.dirty_white,
		},
	},
});

ReactGA.initialize('UA-119387506-1');
const store = configureStore();

//configure api rest root url
const API_ROOT =
	process.env.NODE_ENV === 'development'
		? 'http://dev.toplife.zone'
		: 'https://api.toplife.zone';
configuration.setConfiguration('API_ROOT', API_ROOT);

class App extends Component {
	render() {
		return (
			<MuiThemeProvider theme={theme}>
				<CssBaseline />
				<I18nextProvider i18n={i18n}>
					<Provider store={store}>
						<Root />
					</Provider>
				</I18nextProvider>
			</MuiThemeProvider>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js